export function createTextureBuffer(renderingContext: WebGL2RenderingContext, image: ImageBitmap) {
  const texture = renderingContext.createTexture()
  renderingContext.activeTexture(renderingContext.TEXTURE0)
  renderingContext.bindTexture(renderingContext.TEXTURE_2D, texture)

  renderingContext.texParameteri(
    renderingContext.TEXTURE_2D,
    renderingContext.TEXTURE_WRAP_S,
    renderingContext.CLAMP_TO_EDGE,
  )
  renderingContext.texParameteri(
    renderingContext.TEXTURE_2D,
    renderingContext.TEXTURE_WRAP_T,
    renderingContext.CLAMP_TO_EDGE,
  )
  renderingContext.texParameteri(
    renderingContext.TEXTURE_2D,
    renderingContext.TEXTURE_MIN_FILTER,
    renderingContext.NEAREST,
  )
  renderingContext.texParameteri(
    renderingContext.TEXTURE_2D,
    renderingContext.TEXTURE_MAG_FILTER,
    renderingContext.NEAREST,
  )

  renderingContext.texImage2D(
    renderingContext.TEXTURE_2D,
    0,
    renderingContext.RGBA,
    renderingContext.RGBA,
    renderingContext.UNSIGNED_BYTE,
    image,
  )

  return texture
}
